import type { SVGProps } from "react";

export function IconBlue3PackagesAlt(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_13814_13616)">
        <rect opacity="0.5" width="56" height="56" fill="#E4E7FC" />
        <path
          d="M34 16H22V28.5H16V40H28H40V28.5H34V16Z"
          fill="#5486FA"
          stroke="#5486FA"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <path
          d="M28 40V27M28 27H22V31.5M28 27H34V31.5M28 16V19"
          stroke="#0B0D17"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_13814_13616">
          <rect width="56" height="56" rx="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
